import React, { Component } from 'react';
import {
    Button,
    FormGroup,
    Label,
    Input,
} from 'reactstrap';
import Isvg from "react-inlinesvg";
import xIcon from '../assets/svg/x.svg';
import infoIcon from "../assets/svg/link-new-tab.svg";
import { API_ENDPOINT } from '../constants';
import HTML from './forms/fields/html';
import InfoModal from './infoModal';

class WriteStatement extends Component {
    constructor(props) {
        super(props);
        this.searchResultsWraps = {};


        this.state = {
            ...props.initialData,
            statement: {
                title: '',
                notes: '',
                files: [],
            }
        };
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.conversation?.statement) {
            let statement = {
                title: this.props.conversation?.statement?.title,
                notes: this.props.conversation?.statement?.notes,
                email: this.props.conversation?.statement?.email,
                files: this.props.conversation?.statement?.files,
            }
            this.setState({ statement, lastSavedStatement: JSON.parse(JSON.stringify(statement)), newStatement: { ...statement } })
        } else {
            this.setState({
                newStatement: 'new'
            })
        }
        this.autoSaveInterval = setInterval(() => {
            this.saveStatementInConversation()
        }, 3000);

    }

    componentDidUpdate(prevProps, prevState) {

    }

    componentWillUnmount() {
        this.props.socket.removeListener('statementEvent');

        this.saveStatementInConversation()

        if (this.autoSaveInterval) {
            clearInterval(this.autoSaveInterval)
        }
    }

    saveStatementInConversation = (callback) => {
        let saveStatement = true;
        if (JSON.stringify(this.state.lastSavedStatement) === JSON.stringify(this.state.statement)) {
            saveStatement = false;
        }

        if (this.props.conversation?._id && saveStatement) {
            let statementForSave = this.state.statement ?? { title: '', notes: '', files: [] };
            let data = {
                statement: statementForSave,
                conversationId: this.props.conversation._id,
            }

            fetch(API_ENDPOINT + '/chat/update/statement', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage?.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                this.props.updateStatementInConversation?.(statementForSave)
                this.setState({ lastSavedStatement: JSON.parse(JSON.stringify(statementForSave)) })

                if (callback) {
                    callback()
                }

            })
        } else {
            if (callback) {
                callback()
            }
        }

    }


    saveConversationStatementFiles = async (data) => {
        if (!this.props.conversation?._id || data?.length === 0) return;

        try {
            const res = await fetch(API_ENDPOINT + '/chat/update/statement/conversationStatementFiles', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage?.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    conversationId: this.props.conversation._id,
                    files: data
                })
            });

            const result = await res.json();

            if (result?.data) {
                const statement = { ...this.state.statement };
                statement.files = [...(statement.files || []), ...result.data.filter(Boolean)];
                this.setState({ statement });
            }

            this.saveStatementInConversation();

            return result;

        } catch (err) {
            console.error(err);
        }
    }

    deleteFromConversationStatementFiles = async (id) => {
        if (!this.props.conversation?._id || !id) return;

        try {
            const res = await fetch(API_ENDPOINT + `/chat/update/statement/conversationStatementFiles/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage?.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ conversationId: this.props.conversation._id })
            });

            const result = await res.json();

            if (result?.success) {
                this.setState(prevState => {
                    const statement = { ...prevState.statement };

                    statement.files = (statement.files || []).filter(
                        file => file._id !== id
                    );

                    return { statement };
                });

                this.saveStatementInConversation();
            }

            return result;

        } catch (err) {
            console.error(err);
        }
    }

    saveInPatientProfile = ({ type, skipMessage = false, skipSaveIfNew = false }) => {
        // if (this.state?.newStatement === 'new' && skipSaveIfNew) {
        //     return;
        // }

        let validation = this.checkValidation();
        if (validation) {
            if (skipMessage !== true) {
                this.setState({ message: validation.translate(this.props.lang) })
                return;
            }
        }

        if (this.props.conversation?._id) {
            this.setState({ loadingSave: true }, () => {
                let data = {
                    conversationId: this.props.conversation._id,
                    clinic: this.props.selectedClinic,
                    selectedClinic: this.props.selectedClinic,
                    selectedGroup: this.props.selectedGroup,
                    skipSaveIfNew: skipSaveIfNew || false,
                }
                fetch(API_ENDPOINT + '/statement/save', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage?.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then(res => res.json()).then((result) => {
                    if (skipMessage === true) {
                        this.setState({ loadingSave: false })
                    } else {
                        this.setState({ loadingSave: false, message: 'The statement was successfully saved'.translate(this.props.lang) })
                        this.props.socket.emit('statementEvent', { conversation: this.props.conversation?._id, type: type })
                    }

                })
            })

        }


    }
    sendToEmail = () => {
        let validation = this.checkValidation();
        if (validation) {
            this.setState({ message: validation.translate(this.props.lang) })
            return;
        }


        let statement = {
            title: this.state.statement?.title,
            notes: this.state.statement?.notes
        }
        if (this.props.conversation?._id) {
            this.setState({ loadingPdf: true }, () => {
                let groupAlias = typeof window !== 'undefined' && localStorage ? localStorage?.getItem?.('groupAlias') : null;
                let data = {
                    conversationId: this.props.conversation._id,
                    lang: this.props.lang,
                    selectedClinic: this.props.selectedClinic,
                    selectedGroup: this.props.selectedGroup,
                    groupAlias,
                }
                fetch(API_ENDPOINT + '/statement/create-pdf', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage?.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then(res => res.json()).then((result) => {
                    let pdfCreated = result?.pdfCreated;
                    let emailSent = result?.emailSent;

                    if (pdfCreated) {
                        this.props.updateStatementLastCreatedPdfInConversation?.(statement)
                    }

                    let message;
                    if (!pdfCreated) {
                        message = 'An error occurred while creating the PDF.'.translate(this.props.lang);
                    } else if (pdfCreated && !emailSent?.length) {
                        message = 'The PDF was created but no email was found to be sent to.'.translate(this.props.lang);
                    } else if (pdfCreated && emailSent?.length === 1) {
                        message = `${'The PDF has been created and sent to the following email address'.translate(this.props.lang)}: ${emailSent.join(', ')}.`
                    } else if (pdfCreated && emailSent?.length > 1) {
                        message = `${'The PDF has been created and sent to the following email addresses'.translate(this.props.lang)}: ${emailSent.join(', ')}.`
                    }

                    this.setState({ loadingPdf: false, message })

                })
            })
        }

    }
    checkPdfCreated = () => {
        let returnValue = false;

        if (this.props.conversation?.statementLastCreatedPdf && this.props.conversation?.statement) {
            let statementLastCreatedPdf = {
                title: this.props.conversation.statementLastCreatedPdf?.title,
                notes: this.props.conversation.statementLastCreatedPdf?.notes
            };
            let statement = {
                title: this.props.conversation.statement?.title,
                notes: this.props.conversation.statement?.notes
            };
            if (JSON.stringify(statementLastCreatedPdf) === JSON.stringify(statement)) {
                returnValue = true;
            }
        }
        return returnValue;
    }

    validateStatementForSave = () => {
        const required1 =
            (this.state.statement?.title?.trim()?.length > 0) &&
            (this.state.statement?.notes?.trim()?.length > 0);

        const required2 = this.state.statement?.files?.length > 0;

        if (!required1 && !required2) {
            return false;
        };

        return true;
    }

    checkValidation = () => {
        let title = this.state.statement?.title?.trim() || '';
        let notes = this.state.statement?.notes?.trim() || '';
        let files = this.state.statement?.files || [];

        const hasText = title?.length > 0 && notes?.length > 0;
        const hasFiles = files?.length > 0;

        if (!hasText && !hasFiles) {
            return 'You must provide either Title and Notes or at least one File.';
        }

        return null;
    };

    isStatementDirty = () => {
        const a = this.state?.statement;
        const b = this.state?.newStatement;

        if (!a || !b) return false;

        const titleChanged = a?.title !== b?.title;
        const notesChanged = a?.notes !== b?.notes;

        const aIds = (a?.files || [])?.map(f => f?._id)?.sort();
        const bIds = (b?.files || [])?.map(f => f?._id)?.sort();

        const filesChanged =
            aIds?.length !== bIds?.length ||
            aIds.some((id, i) => id !== bIds[i]);

        return titleChanged || notesChanged || filesChanged;
    };

    render() {
        let checkPdf = this.checkPdfCreated()

        return (
            <div className='write-statement-wrap'>
                {
                    this.state.message ?
                        <InfoModal
                            isOpen={this.state.message}

                            toggle={() => this.setState({ message: null })}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.message}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    this.setState({
                                        message: null
                                    })

                                }}>{'Ok'.translate(this.props.lang)}</Button>
                            ]}
                        />
                        :
                        null
                }

                <div className="chat-write-statement-at-least-text-wrap" >
                    <Label className="chat-write-statement-at-least-text">{'You need to have AT LEAST (Title and Notes) OR (Files) to be able to save statement.'.translate(this.props.lang)}</Label>
                </div>

                <FormGroup>
                    <Label>{'Title'.translate(this.props.lang)}</Label>
                    <Input type='text' onChange={(e) => {
                        let statement = this.state.statement;
                        statement.title = e.target.value;
                        this.setState({ statement })
                    }} value={this.state.statement?.title} />
                </FormGroup>
                <FormGroup style={{ marginTop: '10px' }}>
                    <Label>{'Notes'.translate(this.props.lang)}</Label>
                    <HTML
                        plugins={''}
                        toolbar={[
                            'undo redo | bold | fontsizeselect',
                        ]}
                        disabledMenuBar={true}
                        height={350}
                        value={this.state.statement?.notes} onChange={(text) => {
                            let statement = this.state.statement;
                            statement.notes = text;
                            this.setState({ statement })
                        }} />
                </FormGroup>

                <FormGroup className='chat-write-statement-files-section'>
                    <Label>
                        {'Attachments'.translate(this.props.lang)}
                    </Label>
                    <label className='chat-write-statement-file-btn' htmlFor='chat-write-statement-file-input'>
                        {'Upload files'.translate(this.props.lang)}
                    </label>
                    <Input
                        id="chat-write-statement-file-input"
                        className="chat-write-statement-files-section-file-input"
                        multiple
                        size="sm"
                        type="file"
                        accept="image/png, image/jpeg, image/jpg, image/gif, image/svg, .pdf"
                        onChange={async (e) => {
                            const newFiles = Array.from(e.target.files);
                            e.target.value = '';

                            let results = await Promise.all(
                                newFiles.map(file => {
                                    const uploadType = file.type.startsWith('image/') ? 'image' : 'document';

                                    const fakeEvent = { target: { files: [file] } };

                                    return this.props.uploadDocumentAndImageForStatement(
                                        fakeEvent, true, uploadType
                                    );
                                })
                            );

                            results = (Array.isArray(results) ? results : [results])
                                .flat()
                                .filter(Boolean);

                            const formattedFiles = results.map((filePath, index) => ({
                                file: filePath,
                                name: newFiles[index]?.name || 'file',
                                conversationId: this.props?.conversation?._id
                            }));

                            await this.saveConversationStatementFiles(formattedFiles);
                        }}
                    />
                    {this.state.statement?.files?.length > 0 && (
                        <div className='chat-write-statement-files-list'>
                            {this.state.statement?.files?.map((file, index) => (
                                <div key={index} className='chat-write-statement-file-item'>
                                    <span className='chat-write-statement-file-name'>{file.name}</span>
                                    <button
                                        type='button'
                                        className='chat-write-statement-file-remove'
                                        onClick={async () => {
                                            const statement = { ...this.state.statement };

                                            const file = statement.files?.[index];
                                            if (!file?._id) return;

                                            await this.deleteFromConversationStatementFiles(file._id);

                                            statement.files = statement.files.filter(f => f._id !== file._id);

                                            this.setState({ statement });

                                            const isNew = this.state.newStatement === 'new';
                                            const isDirty = this.isStatementDirty();

                                            if (!isDirty && !isNew) return;

                                            const type = isNew ? 'new' : 'update';

                                            this.setState({ newStatement: { ...this.state.statement } });

                                            this.saveStatementInConversation(() =>
                                                this.saveInPatientProfile({ type, skipMessage: true, skipSaveIfNew: true })
                                            );
                                        }}
                                    >
                                        <Isvg src={xIcon} />
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </FormGroup>

                <FormGroup style={{ marginTop: '10px' }}>
                    <Label>
                        {'Email'.translate(this.props.lang)}
                        <div className="tooltip-wrap">
                            <Isvg src={infoIcon} style={{ width: 20, minWidth: 20, height: 20 }} />
                            <div className="tooltip-on-element">{'The email field is optional, if an email is entered, a link to the PDF will be sent to it. Otherwise, the email address from the patient who is in the chat is used.'.translate(this.props.lang)}</div>
                        </div>
                    </Label>
                    <Input type='text' onChange={(e) => {
                        let statement = this.state.statement;
                        statement.email = e.target.value;
                        this.setState({ statement })
                    }} value={this.state.statement?.email} />
                </FormGroup>
                {/* {
                    checkPdf ?
                        <div className='info-message'>{'PDF created and sent to email!'.translate(this.props.lang)}</div>
                        :
                        null
                } */}
                <div className='write-statement-buttons-wrap'>
                    <div className='save-button-statement'>
                        <Button color='primary' disabled={this.state.loadingSave} onClick={() => {
                            const isNew = this.state.newStatement === 'new';
                            const isDirty = this.isStatementDirty();

                            if (!isDirty && !isNew) return;

                            const type = isNew ? 'new' : 'update';

                            this.setState({
                                newStatement: { ...this.state.statement }
                            });
                            const skipMessage = false;
                            this.saveStatementInConversation(() =>
                                this.saveInPatientProfile({ type, skipMessage: false, skipSaveIfNew: false })
                            );
                        }}>{'Save'.translate(this.props.lang)}</Button>
                        <div className="tabel-action-tooltip-statement"> <Isvg src={infoIcon} /> <div className="chat-icons-tooltip-statement">{"This will save the statement in chat and the patinet's profile. The patinet can access the statement in the chat.".translate(this.props.lang)}</div> </div>

                    </div>

                    <Button color='primary' disabled={this.state.loadingPdf} onClick={() => {
                        this.saveStatementInConversation(() => this.sendToEmail())
                    }}>{'Send email'.translate(this.props.lang)}</Button>
                </div>
            </div>

        );
    }
}


export default WriteStatement;